/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Ambiguous_MappingInputs */

const en_issue_ambiguous_mapping = /** @type {(inputs: Issue_Ambiguous_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`has more than one code in the destination system`)
};

/**
* | output |
* | --- |
* | "has more than one code in the destination system" |
*
* @param {Issue_Ambiguous_MappingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_ambiguous_mapping = /** @type {((inputs?: Issue_Ambiguous_MappingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Ambiguous_MappingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_ambiguous_mapping(inputs)
});